import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetLandUseChangeQuery,
  usePublicGetLandUseChangeQuery,
  useGetLandUseChangeByActivityIdQuery,
  usePublicGetLandUseChangeByActivityIdQuery,
  useUpdateLandUseChangeMutation
} from '../features/modules/landUseChangeApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting land use change data based on the current route.
 */
export const useContextAwareGetLandUseChange = createContextAwareHook(
  useGetLandUseChangeQuery,
  usePublicGetLandUseChangeQuery
);

/**
 * Context-aware hook for getting land use change by activity ID.
 */
export const useContextAwareGetLandUseChangeByActivityId = createContextAwareHook(
  useGetLandUseChangeByActivityIdQuery,
  usePublicGetLandUseChangeByActivityIdQuery
);

// Export mutation hooks directly
export {
  useUpdateLandUseChangeMutation
}; 